





















































import { ContractSmsModalVue } from "fs-pb-vue2/vueModels/contractOperations/ContractSmsModalVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox }
})
export default class ContractSmsModal extends ContractSmsModalVue {
  async mounted() {
    await this.init();
  }
}
